import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { bizpost } from "../../ajax"; // adjust path

type Props = {
  request: any;
};

type State = {
  loading: boolean;
  error: string | null;
  rows: any[];
};

export default class BudgetDrill extends React.Component<Props, State> {
  state: State = {
    loading: false,
    error: null,
    rows: [],
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.request !== this.props.request) {
      this.loadData();
    }
  }

  // Middleware receives:
  // {
  //   s: "dashboard",
  //   a: "drill",
  //   dashboard,
  //   section,
  //   drilltype,
  //   drillcode,
  //   period,
  //   cycle,
  //   scenario,
  //   costcenter,
  //   location,
  //   asofdate
  // }

  loadData = async () => {
    const { request } = this.props;

    this.setState({ loading: true, error: null });

    try {
      const res = await bizpost({
        s: "dashboard",
        a: "drill",
        dashboard: request.dashboard,
        section: request.section,
        drilltype: request.drillType,
        drillcode: request.drillCode,
        ...request.filters,
      });

      this.setState({
        rows: res.sd?.rows || [],
        loading: false,
      });
    } catch (err: any) {
      this.setState({
        error: err?.message || "Unable to load drill data",
        loading: false,
      });
    }
  };

  render() {
    const { loading, error, rows } = this.state;

    if (loading) return <CircularProgress size={28} />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
      <Box>
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {JSON.stringify(rows, null, 2)}
        </pre>
      </Box>
    );
  }
}